export { default as PaymentFailureConfirmation } from "./PaymentFailureConfirmation";
export type { IPaymentFailureConfirmationProps, IPaymentFailureContentProps } from "./types";
